import type { Maybe } from '@adornis/base/utilTypes.js';
import { ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { AdornisFile } from '@adornis/file-utils/db/files.js';

export const SGCONFIG_ID = 'sgconfig';

export enum SUSFormMode {
  ALL = 'all',
  ELEMENTARY_HIGH = 'elementary_high',
}

@Entity()
export class SGConfig extends MongoEntity {
  public static override _class = 'SGConfig';
  public static override _collectionName = 'sg-config';

  @Field(() => String, { default: v => v ?? SGCONFIG_ID })
  public override _id!: string;

  @Field(() => ID)
  kzvkID?: string;

  @Field(() => ID)
  kirchlichesAmtsblattID?: string;

  @Field(() => ID)
  kirchlichesDatenschutzgesetzID?: string;

  @Field(() => ID)
  infosFuerMitarbeiterID?: string;

  @Field(() => ID)
  infectionInformationPaper?: string;

  @Field(() => Date)
  lastDeploy: Maybe<Date>;

  // #region SEPA

  @Field(() => String)
  beraternummer: Maybe<string>;

  @Field(() => String)
  glauberID: Maybe<string>;

  // #endregion

  // #region Quittung Templates

  @Field(() => ID)
  quittungTemplateID: Maybe<string>;

  @DataLoadedField(() => AdornisFile, ({ quittungTemplateID }) => quittungTemplateID)
  quittungTemplate: Maybe<AdornisFile>;

  @Field(() => ID)
  spenderQuittungID: Maybe<string>;

  @DataLoadedField(() => AdornisFile, ({ spenderQuittungID }) => spenderQuittungID)
  spenderQuittung: Maybe<AdornisFile>;

  // #endregion

  // #region Contract Templates

  @Field(() => ID)
  contractTemplateID: Maybe<string>;

  @DataLoadedField(() => AdornisFile, ({ contractTemplateID }) => contractTemplateID)
  contractTemplate: Maybe<AdornisFile>;

  @Field(() => ID)
  supplementTemplateID: Maybe<string>;

  @DataLoadedField(() => AdornisFile, ({ supplementTemplateID }) => supplementTemplateID)
  supplementTemplate: Maybe<AdornisFile>;

  @Field(() => ID)
  gestellungsTemplateID: Maybe<string>;

  @DataLoadedField(() => AdornisFile, ({ gestellungsTemplateID }) => gestellungsTemplateID)
  gestellungsTemplate: Maybe<AdornisFile>;

  @Field(() => ID)
  gestellungsSupplementTemplateID: Maybe<string>;

  @DataLoadedField(() => AdornisFile, ({ gestellungsSupplementTemplateID }) => gestellungsSupplementTemplateID)
  gestellungsSupplementTemplate: Maybe<AdornisFile>;

  // #endregion

  // #region SUS-Form

  @Field(() => Boolean, { default: v => v ?? false })
  activatedSUSForm: Maybe<boolean>;

  // #endregion

  // #region Employment Permit BG-ADD Templates

  @Field(() => ID)
  antragGesundheitszeugnisTemplateID: Maybe<string>;

  @DataLoadedField(() => AdornisFile, ({ antragGesundheitszeugnisTemplateID }) => antragGesundheitszeugnisTemplateID)
  antragGesundheitszeugnisTemplate: Maybe<AdornisFile>;

  @Field(() => ID)
  kenntnisnameInfektionsschutzTemplateID: Maybe<string>;

  @DataLoadedField(
    () => AdornisFile,
    ({ kenntnisnameInfektionsschutzTemplateID }) => kenntnisnameInfektionsschutzTemplateID,
  )
  kenntnisnameInfektionsschutzTemplate: Maybe<AdornisFile>;

  @Field(() => ID)
  beschaeftigungsgenehmigungTemplateID: Maybe<string>;

  @DataLoadedField(
    () => AdornisFile,
    ({ beschaeftigungsgenehmigungTemplateID }) => beschaeftigungsgenehmigungTemplateID,
  )
  beschaeftigungsgenehmigungTemplate: Maybe<AdornisFile>;

  @Field(() => ID)
  personalbogenTemplateID: Maybe<string>;

  @DataLoadedField(() => AdornisFile, ({ personalbogenTemplateID }) => personalbogenTemplateID)
  personalbogenTemplate: Maybe<AdornisFile>;

  @Field(() => ID)
  erklaerungStrafverfahrenTemplateID: Maybe<string>;

  @DataLoadedField(() => AdornisFile, ({ erklaerungStrafverfahrenTemplateID }) => erklaerungStrafverfahrenTemplateID)
  erklaerungStrafverfahrenTemplate: Maybe<AdornisFile>;

  @Field(() => ID)
  antragFuehrungszeugnisTemplateID: Maybe<string>;

  @DataLoadedField(() => AdornisFile, ({ antragFuehrungszeugnisTemplateID }) => antragFuehrungszeugnisTemplateID)
  antragFuehrungszeugnisTemplate: Maybe<AdornisFile>;

  @Field(() => ID)
  psbAVInformationDocumentID: Maybe<string>;

  @DataLoadedField(() => AdornisFile, ({ psbAVInformationDocumentID }) => psbAVInformationDocumentID)
  psbAVInformationDocument: Maybe<AdornisFile>;

  @Field(() => ID)
  masernschutzTemplateID: Maybe<string>;

  @DataLoadedField(() => AdornisFile, ({ masernschutzTemplateID }) => masernschutzTemplateID)
  masernschutzTemplate: Maybe<AdornisFile>;

  // #endregion
}
